import { useEffect, useState } from 'react';
import { getUpcomingTravels } from '../services';
import { IUpcomingTravelItem, HookState } from '../types';
import { resolveErrorMessage } from './hookUtils';

export function useUpcomingTravels(options?: {
	weeks?: number;
	sellerId?: number;
	team?: string;
	enabled?: boolean;
}): HookState<IUpcomingTravelItem[]> {
	const [state, setState] = useState<HookState<IUpcomingTravelItem[]>>({
		data: null,
		loading: true,
		error: null,
		cachedAt: null,
	});

	const sellerId = options?.sellerId;
	const team = options?.team;
	const weeks = options?.weeks;
	const enabled = options?.enabled ?? true;

	useEffect(() => {
		if (!enabled) return;

		let cancelled = false;
		const controller = new AbortController();
		setState((prev) => ({ ...prev, loading: true, error: null }));

		getUpcomingTravels({ weeks, sellerId, team })
			.then(({ data, cachedAt }) => {
				if (!cancelled) setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled && !controller.signal.aborted)
					setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
			controller.abort();
		};
	}, [weeks, sellerId, team, enabled]);

	return state;
}
